import "./index.less";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Empty } from 'antd'

import { Link } from "react-router-dom";
import {
    HistoryOutlined,
    SmileOutlined,
    FireOutlined,
    PaperClipOutlined,
} from "@ant-design/icons";

import { TStoreData, TSubMenuItem } from "@/interface";

import SysConfig from "@/conf/sys.map.config";

const menusText: any = {
    // dipertmentPopularList: "部门最热",
    guessLikeList: "猜你喜欢",
    historyRecordList: "历史记录",
    myCollectList: "我的收藏",
};

const menuIcons: any = {
    // dipertmentPopularList: <FireOutlined />,
    guessLikeList: <SmileOutlined />,
    historyRecordList: <HistoryOutlined />,
    myCollectList: <PaperClipOutlined />,
};

interface TFormatDataItem {
    title: any;
    name: any;
    children: TSubMenuItem[];
}

const RecommendCard = (props: any) => {
    const storeData = useSelector((data: TStoreData) => {
        return {
            customRecord: data?.customRecord || {},
        };
    });
    const { customRecord } = storeData;

    const formatData = (customRecord: {[key: string]: TSubMenuItem[]}) => {
        return Object.keys(customRecord).map((t: any) => {
            const obj = {
                title: menusText[t],
                name: t,
                children: customRecord[t],
            };
            return obj;
        });
    }

    const [customRecordFormat, setCustomRecordFormat] = useState<TFormatDataItem[]>([])

    useEffect(() => {
        setCustomRecordFormat(formatData(customRecord));
    }, [customRecord]);

    return (
        <div className="jx-recommend">
            <div className="jx-recommend-common">
                {customRecordFormat.map((item, index) => {
                    return (
                      <div className="jx-recommend-common-item" key={item.name}>
                        <div className="jx-recommend-common-item-title">
                          {menuIcons[item.name]} {item.title}{" "}
                        </div>
                        <div
                            className={`jx-recommend-common-item-content ${
                                index ===
                                customRecordFormat?.length - 1
                                    ? ""
                                    : "border-right"
                            }`}
                        >
                            {item.children?.length ? item.children.map((child) => {
                                return (
                                    <Link to={
                                        child?.url?.startsWith?.('http')
                                        ? `/iframe-view/${encodeURIComponent(child.url)}`
                                            : SysConfig.base + SysConfig.hash + child.url
                                        } key={child.url}>
                                        {child.name}
                                    </Link>
                                );
                            }) : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={'暂无数据'}/>}
                        </div>
                      </div>
                    );
                })}
            </div>
        </div>
    );
};

export default RecommendCard;
